import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import FsBodyExtraSmall from 'ui-elements/typography/FsBodyExtraSmall';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';
import { TypographyAllProps } from 'globals/types';
import React from 'react';

export const ValueBox = withStyles(({ spacing }: Theme) => ({
  root: {
    paddingLeft: spacing(1),
    textAlign: 'left',
  },
}))(Box);

export const PercentageValue = withStyles(() => ({
  root: {},
}))(FsBodyBold);

export const Value = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))(FsBodyExtraSmall);

export const IncidentsLabel = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.grey[400],
    marginRight: spacing(0.5),
  },
}))(FsBodyExtraSmall);

export const IncidentsValue = withStyles(() => ({
  root: {},
}))((props: TypographyAllProps) => (
  <FsBodySmallBold {...props} component="span" />
));

export const IncidentsBox = withStyles(() => ({
  root: {},
}))((props: BoxProps) => (
  <Box {...props} display="flex" alignItems="baseline" />
));

export const NameBox = withStyles(({ spacing, palette }: Theme) => ({
  root: {
    margin: spacing(0.6, 0),
    borderRight: `1px solid ${palette.grey[200]}`,
  },
}))((props: BoxProps) => <Box {...props} marginRight={1} />);
